import ExportAuditLogs from "../views/admin/auditLogs/components/ExportAuditLogs";
import useModal from "./modalHook";


function useAuditLogs() {
    const { ModalComponent, closeModal, updateModalStates } = useModal();
    const AuditLogsHookModal = ModalComponent;

     const showAuditLogsModal = (admins: any) => {
    updateModalStates({
      show: true,
      size: 'md',
      children: (
        <ExportAuditLogs
          onProceed={() => {
            closeModal();
          }}
          admins={admins}
          onClose={closeModal}
        />
      ),
      title: 'Export Audit Logs As PDF File',
      classes: '!p-0 r-[5px]'
    });
  };

  return {
    AuditLogsHookModal,
    showAuditLogsModal
  }
}

export default useAuditLogs;